import styled from "styled-components";

const FormStyled = styled.form` 

`;


const FormGroupStyled = styled.div`
    /* opacity: ${props => (props.$isActive ? 0 : 1)};
    transition: opacity 2000ms ease; */
`;

export {FormStyled, FormGroupStyled};